import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/loading",
  },
  {
    path: "/loading",
    meta: { title: "首页" },
    component: () => import("@/views/loading"),
  },
  {
    path: "/home",
    meta: { title: "首页" },
    component: () => import("@/views/home"),
  },
  {
    path: "/home/list",
    name: "list",
    meta: { title: "首页" },
    component: () => import("@/views/home/list"),
  },
  {
    path: "/home/list/detail",
    name: "detail",
    meta: { title: "首页" },
    component: () => import("@/views/home/list/detail"),
  },
  {
    path: "/index",
    name: "index",
    meta: { title: "首页" },
    component: () => import("@/views/index"),
  },
  {
    path: "/index/list",
    name: "indexList",
    meta: { title: "列表" },
    component: () => import("@/views/index/list"),
  },
  {
    path: "/index/list/detail",
    name: "indexListDetail",
    meta: { title: "详情" },
    component: () => import("@/views/index/list/detail"),
  },
];

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
